import React from 'react';
import DesktopDevPageArtStage from './primis/DesktopDevPageArtStage';
const DesktopDevPageStage728x90 = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopDevPageArtStage, {
        safety: safety
    });
};
DesktopDevPageStage728x90.displayName = 'DesktopDevPageStage728x90';
export default DesktopDevPageStage728x90;
